/** Answers collected on the sold-dialog shipping step. */
export type SoldDialogShippingAnswers = {
  shipped: boolean | null
  staged: boolean | null
  notShippedReason: string | null
  ourShippingCost: number | null
  customerShippingCost: number | null
  profit: number | null
}

type VehicleShippingRecord = {
  shipped?: boolean | null
  staged?: boolean | null
  not_shipped_reason?: string | null
  our_shipping_cost?: number | null
  customer_shipping_cost?: number | null
  profit?: number | null
} | null

export function soldDialogShippingFromVehicle(
  shipping?: VehicleShippingRecord,
): SoldDialogShippingAnswers | undefined {
  if (!shipping) return undefined
  return {
    shipped: shipping.shipped ?? null,
    staged: shipping.staged ?? null,
    notShippedReason: shipping.not_shipped_reason ?? null,
    ourShippingCost: shipping.our_shipping_cost ?? null,
    customerShippingCost: shipping.customer_shipping_cost ?? null,
    profit: shipping.profit ?? null,
  }
}

/** Firestore `shipping` map. Null when the shipped question was not answered. */
export function storedShippingFromDialog(
  shippingInfo?: {
    shipped: boolean | null
    staged?: boolean | null
    notShippedReason?: string | null
    ourShippingCost: number | null
    customerShippingCost: number | null
    profit: number | null
  } | null,
) {
  if (!shippingInfo || shippingInfo.shipped == null) return null

  const shipped = shippingInfo.shipped === true
  const staged = shipped ? null : shippingInfo.staged === true ? true : shippingInfo.staged === false ? false : null
  const notShippedReason =
    !shipped && staged === false ? shippingInfo.notShippedReason?.trim() || null : null

  return {
    shipped,
    staged,
    not_shipped_reason: notShippedReason,
    our_shipping_cost: shipped && shippingInfo.ourShippingCost != null ? Number(shippingInfo.ourShippingCost) : null,
    customer_shipping_cost:
      shipped && shippingInfo.customerShippingCost != null ? Number(shippingInfo.customerShippingCost) : null,
    profit: shipped && shippingInfo.profit != null ? Number(shippingInfo.profit) : null,
  }
}
